export default __webpack_public_path__ + "static/Ivana-7630749795632427d8a60ffbdb5d16d1.jpg";